import { useEffect, useState } from 'react'

import * as api from '../api'
import { handleRedirectOnUnauth, URL_PARAM_KEY } from '../business'
import Providers from './Providers'
import LoadingReadingBar from './LoadingReadingBar'

const App = () => {
  const encodedMediaUrl = new URLSearchParams(window.location.search).get(
    URL_PARAM_KEY,
  )
  const mediaUrl =
    typeof encodedMediaUrl === 'string'
      ? decodeURIComponent(encodedMediaUrl)
      : encodedMediaUrl

  const [loadingIsUserAuthenticated, setLoadingIsUserAuthenticated] = useState(true)


  useEffect(() => {
    ; (async () => {
      const { isAuthenticated } = await api.verifyIsUserAuthenticated()
      if (!isAuthenticated) {
        handleRedirectOnUnauth()
      } else {
        setLoadingIsUserAuthenticated(false)
      }
    })()
  }, [])

  if (mediaUrl === null || loadingIsUserAuthenticated) return null
  return (
    <Providers>
      <LoadingReadingBar mediaUrl={mediaUrl} />
    </Providers>
  )
}

export default App
